export const PAGE_SIZE = 2000
export const MAX_TOTAL = 200_000
export const MAX_PAGE_ATTEMPTS = 6
// Паузы МЕЖДУ попытками: 6 попыток = 5 пауз. После 6-й неудачи — пауза onPause.
export const BACKOFF_MS = [1000, 2000, 4000, 8000, 16000] as const
export const MAX_PAGE_BYTES = 10 * 1024 * 1024
export const COMMIT_MISMATCH_CYCLES = 3
